document.addEventListener('DOMContentLoaded',function(){
  var btn=document.querySelector('.menu-btn'),nav=document.querySelector('.mnav');
  if(btn&&nav){btn.addEventListener('click',function(){var o=nav.classList.toggle('open');btn.setAttribute('aria-expanded',o)});
    nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){nav.classList.remove('open')})});}
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var items=g.querySelectorAll('.gallery-item'),more=g.querySelector('.load-more'),step=6,shown=step;
    function upd(){items.forEach(function(it,i){it.hidden=i>=shown});if(more)more.hidden=shown>=items.length}
    upd(); if(more)more.addEventListener('click',function(){shown+=step;upd()});
    var lb=document.createElement('div');lb.className='lightbox';lb.hidden=true;lb.innerHTML='<img alt="">';document.body.appendChild(lb);
    lb.addEventListener('click',function(){lb.hidden=true});
    items.forEach(function(it){it.addEventListener('click',function(){var im=lb.querySelector('img');im.src=it.dataset.full;im.alt=(it.querySelector('img')||{}).alt||'';lb.hidden=false})});
  });
});
